<div class="page">
  @if (!isLoading() && human(); as currentHuman) {
  <button type="button" appBackNavigation class="back-link mb-5">
    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
    {{ 'common.back' | translate }}
  </button>

  <!-- Profile banner -->
  <div class="relative mb-8 flex min-h-64 items-end overflow-hidden rounded-3xl bg-slate-900 shadow-xl md:min-h-80">
    <img [src]="currentHuman.coverImageUrl || '/assets/club-background-forest.webp'" alt=""
      class="absolute inset-0 h-full w-full object-cover opacity-50 blur-[2px]">
    <div class="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/55 to-slate-950/10"></div>
    <div class="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-slate-950/95 via-slate-950/65 to-transparent"></div>

    <a [routerLink]="['/compare/human', currentHuman.id]" [attr.title]="'compare.versusHint' | translate"
      class="accent-solid absolute right-4 top-4 z-20 inline-flex items-center gap-2 rounded-xl px-4 py-2 text-xs font-black uppercase tracking-widest shadow-lg transition-transform hover:-translate-y-0.5 md:right-6 md:top-6">
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
      {{ 'compare.versus' | translate }}
    </a>

    <div class="relative z-10 flex w-full min-w-0 flex-col gap-4 p-6 sm:flex-row sm:items-end sm:gap-6 md:p-10">
      <div class="relative shrink-0 self-start sm:self-auto">
        <app-human-avatar
          [imageUrl]="currentHuman.imageUrl"
          [gender]="currentHuman.gender"
          [name]="currentHuman.name"
          class="h-24 w-24 overflow-hidden rounded-3xl border-4 border-white shadow-2xl dark:border-slate-800 md:h-36 md:w-36" />
        <div class="absolute -bottom-2 -right-2 rounded-xl border-2 border-white bg-white/90 p-1.5 shadow-lg dark:border-slate-800 dark:bg-slate-800">
          <span class="text-lg leading-none">{{ getFlagEmoji(currentHuman.nationality) }}</span>
        </div>
      </div>
      <div class="min-w-0">
        <h1 class="profile-title text-white drop-shadow-lg">
          {{ currentHuman.name }} <app-registered-star [humanId]="currentHuman.id" />
        </h1>
        <div class="mt-3 flex flex-wrap items-center gap-2">
          @if (currentHuman.age) {
            <span class="rounded-full bg-white/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white backdrop-blur-md">
              {{ currentHuman.age }} {{ 'humanProfile.years' | translate }}
            </span>
          }
          @if (currentHuman.gender) {
            <span class="rounded-full bg-white/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white backdrop-blur-md">
              {{ genderLabel(currentHuman.gender) }}
            </span>
          }
          @if(currentHuman.club) {
            <span class="accent-solid max-w-full truncate rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider">
              {{ currentHuman.club }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>

  <div>
    @if (isAdmin()) {
      <div class="mb-5 flex justify-end">
        <button type="button" (click)="adminEditOpen() ? adminEditOpen.set(false) : openAdminEdit()"
          class="btn btn-secondary">
          {{ (adminEditOpen() ? 'humanProfile.admin.close' : 'humanProfile.admin.open') | translate }}
        </button>
      </div>
      @if (adminEditOpen()) {
        <section class="card mb-8 p-6">
          <h2 class="section-title mb-5">{{ 'humanProfile.admin.title' | translate }}</h2>
          <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <label class="field-label">{{ 'humanProfile.admin.name' | translate }}<input class="field mt-1" [ngModel]="adminDraft().name" (ngModelChange)="updateAdminDraft('name', $event)"></label>
            <label class="field-label">{{ 'humanProfile.admin.age' | translate }}<input type="number" min="0" class="field mt-1" [ngModel]="adminDraft().age" (ngModelChange)="updateAdminDraft('age', $event)"></label>
            <label class="field-label">{{ 'humanProfile.admin.gender' | translate }}<select class="field mt-1" [ngModel]="adminDraft().gender" (ngModelChange)="updateAdminDraft('gender', $event)"><option value="Male">{{ 'humanProfile.genders.Male' | translate }}</option><option value="Female">{{ 'humanProfile.genders.Female' | translate }}</option><option value="Other">{{ 'humanProfile.genders.Other' | translate }}</option></select></label>
            <label class="field-label">{{ 'humanProfile.admin.nationality' | translate }}<input class="field mt-1" [ngModel]="adminDraft().nationality" (ngModelChange)="updateAdminDraft('nationality', $event)"></label>
            <div class="field-label">{{ 'humanProfile.admin.club' | translate }}<app-club-picker [clubName]="adminDraft().clubName" [ariaLabel]="'humanProfile.admin.club' | translate"
              inputClass="field mt-1"
              (clubChange)="adminClubSelection.set($event)" /></div>
            <label class="field-label">{{ 'humanProfile.admin.photo' | translate }}<input class="field mt-1" [ngModel]="adminDraft().imageUrl" (ngModelChange)="updateAdminDraft('imageUrl', $event)"></label>
          </div>
          <div class="my-6 flex items-center justify-between border-t pt-5 dark:border-slate-800">
            <h3 class="font-black text-slate-900 dark:text-white">{{ 'humanProfile.admin.dogsTitle' | translate }}</h3>
            <button type="button" (click)="addAdminDog()" class="btn btn-secondary px-3 py-2">{{ 'humanProfile.admin.addDog' | translate }}</button>
          </div>
          <div class="space-y-3">
            @for (dog of adminDogs(); track dog.id || $index; let index = $index) {
              <div class="grid gap-3 rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/50 md:grid-cols-6">
                <input [attr.aria-label]="'humanProfile.admin.dogName' | translate" [placeholder]="'humanProfile.admin.dogNamePlaceholder' | translate" class="field px-3 py-2" [ngModel]="dog.name" (ngModelChange)="updateAdminDog(index, 'name', $event)">
                <input [attr.aria-label]="'humanProfile.admin.dogBreed' | translate" [placeholder]="'humanProfile.admin.dogBreedPlaceholder' | translate" class="field px-3 py-2" [ngModel]="dog.breed" (ngModelChange)="updateAdminDog(index, 'breed', $event)">
                <input [attr.aria-label]="'humanProfile.admin.dogAge' | translate" type="number" min="0" [placeholder]="'humanProfile.admin.dogAgePlaceholder' | translate" class="field px-3 py-2" [ngModel]="dog.age" (ngModelChange)="updateAdminDog(index, 'age', $event)">
                <select [attr.aria-label]="'humanProfile.admin.dogSex' | translate" class="field px-3 py-2" [ngModel]="dog.gender" (ngModelChange)="updateAdminDog(index, 'gender', $event)"><option value="Male">{{ 'humanProfile.admin.dogMale' | translate }}</option><option value="Female">{{ 'humanProfile.admin.dogFemale' | translate }}</option></select>
                <input [attr.aria-label]="'humanProfile.admin.dogPhoto' | translate" [placeholder]="'humanProfile.admin.dogPhotoPlaceholder' | translate" class="field px-3 py-2" [ngModel]="dog.imageUrl" (ngModelChange)="updateAdminDog(index, 'imageUrl', $event)">
                <button type="button" (click)="deleteAdminDog(index)" class="rounded-xl bg-red-50 px-3 py-2 text-xs font-bold text-red-600 dark:bg-red-950/30">{{ 'humanProfile.admin.deleteDog' | translate }}</button>
              </div>
            }
          </div>
          <details class="mt-6 rounded-2xl border border-amber-200 bg-amber-50/60 p-4 dark:border-amber-900 dark:bg-amber-950/20">
            <summary class="cursor-pointer text-sm font-black text-amber-900 dark:text-amber-200">{{ 'humanProfile.admin.mergeTitle' | translate }}</summary>
            <p class="mt-2 text-xs text-amber-800 dark:text-amber-300">{{ 'humanProfile.admin.mergeHint' | translate }}</p>

            <div class="mt-5 rounded-2xl bg-white p-4 dark:bg-slate-900">
              <h4 class="font-black text-slate-900 dark:text-white">{{ 'humanProfile.admin.mergeProfileTitle' | translate }}</h4>
              <p class="mt-1 text-xs text-slate-500">{{ 'humanProfile.admin.mergeProfileHint' | translate }}</p>
              <div class="mt-3 flex flex-col gap-2 sm:flex-row">
                <input [attr.aria-label]="'humanProfile.admin.mergeSearchLabel' | translate" [placeholder]="'humanProfile.admin.mergeSearchPlaceholder' | translate"
                  class="field min-w-0 flex-1"
                  [ngModel]="adminMergeQuery()" (ngModelChange)="adminMergeQuery.set($event)" (keyup.enter)="searchAdminMergeCandidates()">
                <button type="button" (click)="searchAdminMergeCandidates()" [disabled]="adminMergeSearching() || adminMergeQuery().trim().length < 3"
                  class="btn btn-secondary">
                  {{ (adminMergeSearching() ? 'humanProfile.admin.searching' : 'humanProfile.admin.search') | translate }}
                </button>
              </div>
              @if (adminMergeCandidates().length) {
                <div class="mt-3 space-y-2">
                  @for (candidate of adminMergeCandidates(); track candidate.id) {
                    <div class="flex items-center justify-between gap-3 rounded-xl bg-slate-50 p-3 dark:bg-slate-800">
                      <span class="min-w-0"><strong class="block truncate text-sm text-slate-900 dark:text-white">{{ candidate.name }}</strong><small class="text-slate-500">{{ candidate.club || ('humanProfile.admin.noClub' | translate) }}</small></span>
                      <button type="button" (click)="mergeAdminProfile(candidate)" [disabled]="adminMerging()"
                        class="shrink-0 rounded-xl bg-amber-600 px-3 py-2 text-xs font-black text-white disabled:opacity-50">{{ 'humanProfile.admin.mergeHere' | translate }}</button>
                    </div>
                  }
                </div>
              }
            </div>

            @if (adminDogs().length > 1) {
              <div class="mt-4 rounded-2xl bg-white p-4 dark:bg-slate-900">
                <h4 class="font-black text-slate-900 dark:text-white">{{ 'humanProfile.admin.mergeDogsTitle' | translate }}</h4>
                <div class="mt-3 grid gap-3 md:grid-cols-2">
                  <label class="field-label">{{ 'humanProfile.admin.duplicateDog' | translate }}
                    <select class="field mt-1" [ngModel]="adminDogMergeSourceId()" (ngModelChange)="adminDogMergeSourceId.set($event)">
                      <option value="">{{ 'humanProfile.admin.choose' | translate }}</option>@for (dog of adminDogs(); track dog.id) { <option [value]="dog.id" [disabled]="dog.id === adminDogMergeTargetId()">{{ dog.name }} — {{ (dog.breed | breedName) || ('humanProfile.admin.unknownBreed' | translate) }}</option> }
                    </select>
                  </label>
                  <label class="field-label">{{ 'humanProfile.admin.keptDog' | translate }}
                    <select class="field mt-1" [ngModel]="adminDogMergeTargetId()" (ngModelChange)="adminDogMergeTargetId.set($event)">
                      <option value="">{{ 'humanProfile.admin.choose' | translate }}</option>@for (dog of adminDogs(); track dog.id) { <option [value]="dog.id" [disabled]="dog.id === adminDogMergeSourceId()">{{ dog.name }} — {{ (dog.breed | breedName) || ('humanProfile.admin.unknownBreed' | translate) }}</option> }
                    </select>
                  </label>
                </div>
                <button type="button" (click)="mergeAdminDogs()" [disabled]="!adminDogMergeSourceId() || !adminDogMergeTargetId() || adminDogMergeSourceId() === adminDogMergeTargetId() || adminMerging()"
                  class="mt-3 rounded-xl bg-amber-600 px-4 py-3 text-xs font-black text-white disabled:opacity-50">
                  {{ (adminMerging() ? 'humanProfile.admin.merging' : 'humanProfile.admin.mergeDogs') | translate }}
                </button>
              </div>
            }
          </details>
          @if (adminError()) { <p role="alert" class="mt-4 text-sm font-bold text-red-600">{{ 'humanProfile.admin.saveError' | translate }}</p> }
          <div class="mt-6 flex justify-end"><button type="button" (click)="saveAdminProfile()" [disabled]="adminSaving()" class="btn btn-primary">{{ (adminSaving() ? 'humanProfile.admin.saving' : 'humanProfile.admin.save') | translate }}</button></div>
        </section>
      }
    }
    <div class="mb-12">
      <app-human-profile-stats
        [results]="scopedResults()"
        [showFavoriteDog]="true"
      />
    </div>

    <div class="mb-8 flex flex-col gap-3 px-2 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p class="text-xs font-black uppercase tracking-widest text-slate-400">
          {{ 'humanProfile.statsPeriod' | translate }}
        </p>
        <p class="mt-1 text-sm font-black text-slate-700 dark:text-slate-200">{{ statsScopeLabel() }}</p>
      </div>
      <app-styled-select
        [options]="statsPeriodOptions()"
        [value]="statsScope() === 'all' ? 'all' : selectedSeasonStart().toString()"
        [ariaLabel]="'humanProfile.statsPeriod' | translate"
        [fullWidth]="true"
        class="w-full sm:w-64"
        density="comfortable"
        (valueChange)="setStatsPeriod($event)"
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-8">
      <!-- Sidebar: Shared Info -->
      <div class="lg:col-span-1 space-y-8">
        <div
          class="card p-8">
          <h2 class="section-title mb-6 flex items-center gap-3">
            <span class="accent-solid w-8 h-8 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </span>
            {{ 'humanProfile.about' | translate }}
          </h2>
          <div class="space-y-6">
            <div>
              <dt class="text-xs font-black text-slate-400 uppercase tracking-widest mb-2">{{ 'humanProfile.club' |
                translate }}</dt>
              <dd class="text-slate-700 dark:text-slate-300 font-medium">{{ currentHuman.club | displayValue }}</dd>
            </div>
            <div>
              <dt class="text-xs font-black text-slate-400 uppercase tracking-widest mb-2">{{ 'humanProfile.nationality'
                | translate }}</dt>
              <dd class="text-slate-700 dark:text-slate-300 font-medium flex items-center gap-2">
                <span>{{ getFlagEmoji(currentHuman.nationality) }}</span>
                {{ currentHuman.nationality | displayValue }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-black text-slate-400 uppercase tracking-widest mb-2">{{ 'humanProfile.gender' |
                translate }}</dt>
              <dd class="text-slate-700 dark:text-slate-300 font-medium">{{ genderLabel(currentHuman.gender) }}</dd>
            </div>
            @if (currentHuman.age) {
            <div>
              <dt class="text-xs font-black text-slate-400 uppercase tracking-widest mb-2">{{ 'humanProfile.age' |
                translate }}</dt>
              <dd class="text-slate-700 dark:text-slate-300 font-medium">{{ currentHuman.age }} {{ 'humanProfile.years'
                | translate }}</dd>
            </div>
            }
            @if (profileDogs().length) {
            <div class="border-t border-slate-100 dark:border-slate-800 pt-6">
              <dt class="text-xs font-black text-slate-400 uppercase tracking-widest mb-1">{{ 'humanProfile.dogs' | translate }}</dt>
              <p class="mb-3 text-[10px] font-bold uppercase tracking-wider text-slate-400">{{ translationService.currentLang() === 'fr' ? 'Classement par nombre de courses' : 'Ranking by number of races' }}</p>
              <div class="space-y-3">
                @for (dog of profileDogs(); track dog.id; let rank = $index) {
                <a [routerLink]="['/dog-profile', dog.id]"
                  class="block rounded-2xl border border-slate-100 p-3 hover:bg-slate-50 dark:border-slate-800 dark:hover:bg-slate-800 transition-colors">
                  <div class="flex items-center gap-3">
                  <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-900 text-[10px] font-black text-white dark:bg-white dark:text-slate-900">{{ rank + 1 }}</span>
                  @if (dog.imageUrl) {
                  <img [src]="dog.imageUrl" [alt]="dog.name" class="h-10 w-10 rounded-xl object-cover">
                  } @else {
                  <div class="h-10 w-10 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 flex items-center justify-center font-black">
                    {{ dog.name.charAt(0).toUpperCase() }}
                  </div>
                  }
                  <span class="min-w-0">
                    <span class="block truncate text-sm font-black text-slate-700 dark:text-slate-200">{{ dog.name }} @if (dog.age !== undefined && dog.age !== null) { <span class="font-semibold text-slate-400">({{ dog.age }} {{ 'humanProfile.years' | translate }})</span> }</span>
                    <span class="block truncate text-xs text-slate-400">
                      {{ (dog.breed | breedName) | displayValue }}
                    </span>
                  </span>
                  </div>
                  <div class="mt-3 grid grid-cols-2 gap-2 text-xs">
                    <span class="rounded-lg bg-slate-100 px-2 py-1.5 dark:bg-slate-700"><strong>{{ dog.races }}</strong> {{ translationService.currentLang() === 'fr' ? 'courses' : 'races' }}</span>
                    <span class="rounded-lg bg-slate-100 px-2 py-1.5 dark:bg-slate-700"><strong>{{ dog.distance | distance }} km</strong></span>
                  </div>
                  <div class="mt-2 flex flex-wrap gap-1">
                    @for (discipline of dog.disciplines; track discipline.name) {
                      <span class="rounded-md bg-slate-100 px-1.5 py-1 text-[9px] font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">{{ discipline.name }} · {{ discipline.races }} · {{ discipline.distance | distance }} km</span>
                    }
                  </div>
                </a>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Main Content: Race History -->
      <div class="lg:col-span-2 2xl:col-span-3 space-y-8">
        <!-- Palmarès -->
        @if (hasPodiums()) {
        <div class="grid grid-cols-2 xl:grid-cols-4 gap-4">
          <div class="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 flex items-center space-x-4">
             <div class="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center text-yellow-900 shadow-inner">
               <span class="text-xl">🥇</span>
             </div>
             <div>
               <p class="text-2xl font-black text-slate-900 dark:text-slate-100">{{ podiums().first }}</p>
               <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ 'humanProfile.palmares.victories' | translate }}</p>
             </div>
          </div>
          <div class="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 flex items-center space-x-4">
             <div class="w-10 h-10 bg-slate-300 rounded-full flex items-center justify-center text-slate-700 shadow-inner">
               <span class="text-xl">🥈</span>
             </div>
             <div>
               <p class="text-2xl font-black text-slate-900 dark:text-slate-100">{{ podiums().second }}</p>
               <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ 'humanProfile.palmares.silver' | translate }}</p>
             </div>
          </div>
          <div class="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 flex items-center space-x-4">
             <div class="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center text-amber-100 shadow-inner">
               <span class="text-xl">🥉</span>
             </div>
             <div>
               <p class="text-2xl font-black text-slate-900 dark:text-slate-100">{{ podiums().third }}</p>
               <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ 'humanProfile.palmares.bronze' | translate }}</p>
             </div>
          </div>
          <div class="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 flex items-center space-x-4">
             <div class="w-10 h-10 bg-orange-900 rounded-full flex items-center justify-center text-orange-100 shadow-inner">
               <span class="text-xl">🍫</span>
             </div>
             <div>
               <p class="text-2xl font-black text-slate-900 dark:text-slate-100">{{ podiums().fourth }}</p>
               <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ 'humanProfile.palmares.chocolate' | translate }}</p>
             </div>
          </div>
        </div>
        }

        <div class="card overflow-hidden">
          <div class="flex items-center justify-between border-b border-slate-100 p-8 dark:border-slate-800">
            <h2 class="section-title uppercase">{{ 'teamProfile.raceHistory' | translate }}</h2>
            <span class="rounded-2xl bg-slate-100 px-5 py-2 text-xs font-black uppercase tracking-widest text-slate-500 dark:bg-slate-800">
              {{ totalRaces() }} {{ 'humanProfile.stats.races' | translate }}
            </span>
          </div>

          <div class="p-6 md:p-8">
            @if (resultsBySeason().length === 0) {
              <div class="py-20 text-center text-sm font-black uppercase tracking-widest text-slate-400">{{ 'myProfile.noRaces' | translate }}</div>
            } @else {
              <div class="space-y-10">
                @for (season of resultsBySeason(); track season[0]) {
                  <section>
                    <div class="mb-4 flex items-center gap-3 px-1">
                      <h4 class="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-slate-100">{{ 'common.season' | translate }} {{ seasonLabel(season[0]) }}</h4>
                      <span class="rounded-full bg-slate-100 px-3 py-1 text-[10px] font-black uppercase tracking-widest text-slate-500 dark:bg-slate-800">{{ season[1].length }} {{ 'humanProfile.stats.races' | translate }}</span>
                      <div class="h-px flex-1 bg-slate-100 dark:bg-slate-800"></div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                      @for (result of season[1]; track result.id) {
                        <article class="group rounded-2xl border border-slate-100 bg-slate-50/70 p-5 transition-all hover:-translate-y-0.5 hover:shadow-lg dark:border-slate-800 dark:bg-slate-800/40">
                          <div class="mb-3 flex items-start justify-between gap-3">
                            <div class="min-w-0">
                              <a [routerLink]="['/race-detail', result.event?.id]" class="block break-words text-sm font-black text-slate-900 underline-offset-4 transition-colors hover:text-[color:var(--accent-logo)] hover:underline dark:text-slate-100">{{ result.event?.name || result.race.name }}</a>
                              @if (result.event?.name && result.race.name !== result.event?.name) { <p class="mt-1 text-xs font-semibold text-slate-600 dark:text-slate-300">{{ result.race.name }}</p> }
                              <p class="mt-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{{ formatDate(result.event?.date || '') }}</p>
                            </div>
                            <span class="shrink-0 font-mono text-sm font-black text-slate-700 dark:text-slate-200">{{ result.statusCode ? (result.statusCode | resultStatus:result.statusLabel:result.statusRaw) : (result.statusLabel || formatTime(result.timeSeconds)) }}</span>
                          </div>
                          <div class="mb-3 flex flex-wrap items-center gap-2">
                            <span class="accent-soft rounded-lg px-2.5 py-1 text-[10px] font-black uppercase tracking-wider">{{ (result.discipline ?? result.race.discipline ?? result.race.name) | disciplineLabel }}</span>
                            @if (result.race.distanceKm) { <span class="rounded-lg bg-slate-100 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-slate-500 dark:bg-slate-700/60 dark:text-slate-300">{{ result.race.distanceKm | distance }} km</span> }
                            @if (result.team?.dog; as dog) { <a [routerLink]="['/dog-profile', dog.id]" class="rounded-lg bg-slate-100 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-slate-700 transition-colors hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700">{{ dog.name }}</a> }
                          </div>
                          <div class="flex items-center gap-2 border-t border-slate-100 pt-3 dark:border-slate-700/60">
                            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">{{ 'myProfile.scratch' | translate }}</span>
                            <span class="text-sm font-black text-slate-900 dark:text-slate-100">@if (result.position) { #{{ result.position }} } @else { {{ null | displayValue }} }</span>
                            <span class="text-[10px] font-bold text-slate-400">/{{ participantCounts()[result.raceId] || 0 }}</span>
                            @if (result.category) {
                              <span class="ml-auto inline-flex items-center gap-1 rounded-lg bg-slate-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wider text-slate-500" [class.bg-yellow-100]="result.categoryRank === 1" [class.text-yellow-800]="result.categoryRank === 1">
                                {{ 'common.categoryShort' | translate }} {{ result.category }} @if (result.categoryRank) { #{{ result.categoryRank }} } @else { {{ null | displayValue }} }
                              </span>
                            }
                          </div>
                        </article>
                      }
                    </div>
                  </section>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  } @else if (isLoading()) {
  <div class="min-h-[60vh]" aria-busy="true" [attr.aria-label]="'common.loading' | translate">
    <app-branded-loader mode="compact" [label]="'common.loading' | translate" />
    <div class="mx-auto max-w-[1600px] animate-pulse">
      <div class="h-64 md:h-80 rounded-3xl bg-slate-200 dark:bg-slate-800"></div>
      <div class="relative -mt-16 px-4 md:px-8">
        <div class="flex items-end gap-5">
          <div class="h-24 w-24 md:h-40 md:w-40 shrink-0 rounded-3xl bg-slate-300 dark:bg-slate-700 border-4 border-slate-50 dark:border-slate-950"></div>
          <div class="space-y-3 pb-3 flex-1">
            <div class="h-8 w-64 rounded-lg bg-slate-300 dark:bg-slate-700"></div>
            <div class="flex gap-3">
              <div class="h-6 w-20 rounded-full bg-slate-300 dark:bg-slate-700"></div>
              <div class="h-6 w-24 rounded-full bg-slate-300 dark:bg-slate-700"></div>
              <div class="h-6 w-32 rounded-full bg-slate-300 dark:bg-slate-700"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
        @for (card of [1, 2, 3, 4]; track card) {
        <div class="h-32 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-6">
          <div class="h-3 w-28 rounded bg-slate-200 dark:bg-slate-800 mb-5"></div>
          <div class="h-8 w-20 rounded bg-slate-200 dark:bg-slate-800"></div>
        </div>
        }
      </div>
      <div class="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div class="h-72 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800"></div>
        <div class="lg:col-span-2 space-y-5">
          <div class="h-8 w-48 rounded bg-slate-200 dark:bg-slate-800"></div>
          @for (row of [1, 2, 3]; track row) {
          <div class="h-36 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800"></div>
          }
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
    <div class="w-24 h-24 bg-slate-100 dark:bg-slate-800 rounded-3xl flex items-center justify-center mb-6">
      <svg class="w-12 h-12 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M9.172 9.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h1 class="text-3xl font-black text-slate-900 dark:text-slate-100 mb-2">{{ 'humanProfile.notFound' | translate }}</h1>
    <p class="text-slate-500 mb-8 max-w-sm">{{ 'humanProfile.notFoundDesc' | translate }}</p>
    <button type="button" appBackNavigation class="btn btn-primary">
      {{ 'humanProfile.back' | translate }}
    </button>
  </div>
  }
</div>
